/* =============================================================================
   demo-pagos.js — Vista previa de «Reserva Directa» (precio + pago al instante)

   DEMO para mostrar al hotel (2026-10-22). Solo se activa con ?demo=pagos en
   la URL de Habitaciones (y se recuerda en la pestaña): el sitio público no
   cambia. No hay precios reales, ni pasarela, ni se envía ningún dato: los
   precios son esqueletos y el formulario de tarjeta es un marcador del que
   pondrá la pasarela (Izipay, Niubiz, Culqi…). Cuando exista el sistema real
   (PHP + MySQL en Plesk), este flujo se conecta a su API.
   ============================================================================= */
(function () {
  'use strict';

  var CLAVE = 'lg-demo-pagos';
  var activo = /[?&]demo=pagos\b/.test(location.search);
  try {
    if (activo) sessionStorage.setItem(CLAVE, '1');
    else activo = sessionStorage.getItem(CLAVE) === '1';
  } catch (e) { /* sin almacenamiento: solo vale el parámetro */ }
  var raiz = document.getElementById('habCatalogo');
  if (!activo || !raiz) return;

  /* ── Estilos (autocontenidos: la demo no toca las hojas del sitio) ─────── */
  var css = [
    '.dp-precio{margin-right:auto;display:grid;gap:2px;background:none;border:0;padding:0;font:inherit;text-align:left;cursor:pointer;color:var(--ink)}',
    '.dp-precio small{font-size:11px;letter-spacing:1px;text-transform:uppercase;color:var(--soft)}',
    '.dp-monto{display:flex;align-items:baseline;gap:6px;font-family:"Cormorant Garamond",Georgia,serif;font-size:22px}',
    '.dp-monto em{font-style:normal;font-family:inherit;font-size:12px;color:var(--soft)}',
    '.dp-sk{display:inline-block;height:.8em;width:4.2em;border-radius:3px;background:linear-gradient(90deg,rgba(43,43,38,.1),rgba(43,43,38,.2),rgba(43,43,38,.1));background-size:200% 100%;animation:dpBrillo 1.6s linear infinite;vertical-align:middle}',
    '.dp-precio:hover .dp-ver,.dp-precio:focus-visible .dp-ver{text-decoration:underline}',
    '.dp-ver{font-size:11px;letter-spacing:1px;text-transform:uppercase;color:var(--green)}',
    '@keyframes dpBrillo{to{background-position:-200% 0}}',
    '.dp-modal{position:fixed;inset:0;margin:auto;height:fit-content;overflow:auto;width:min(560px,calc(100vw - 24px));max-height:calc(100dvh - 24px);border:0;padding:0;background:#FBF8F1;color:#22221E;box-shadow:0 30px 80px rgba(0,0,0,.35)}',
    '.dp-modal::backdrop{background:rgba(16,24,14,.55)}',
    '.dp-banda{background:#284323;color:#F4F7EE;font-size:11.5px;letter-spacing:1px;text-transform:uppercase;padding:8px 20px;display:flex;justify-content:space-between;gap:12px}',
    '.dp-cuerpo{padding:22px 24px 26px;display:grid;gap:18px}',
    '.dp-cab{display:flex;justify-content:space-between;align-items:start;gap:16px}',
    '.dp-cab h2{margin:0;font-family:"Cormorant Garamond",Georgia,serif;font-weight:400;font-size:28px;line-height:1.1}',
    '.dp-cerrar{background:none;border:0;font-size:26px;line-height:1;cursor:pointer;color:inherit;padding:2px 6px}',
    '.dp-pasos{display:grid;grid-template-columns:repeat(4,1fr);gap:6px;list-style:none;margin:0;padding:0;font-size:11px;letter-spacing:.8px;text-transform:uppercase;color:#6B6B60}',
    '.dp-pasos li{border-top:2px solid rgba(43,43,38,.15);padding-top:6px}',
    '.dp-pasos li[aria-current],.dp-pasos li.hecho{border-color:#374F2D;color:#374F2D}',
    '.dp-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}',
    '.dp-modal label{display:grid;gap:5px;font-size:12px;letter-spacing:.6px;text-transform:uppercase;color:#4D4940}',
    '.dp-modal input,.dp-modal select{font:inherit;font-size:15px;text-transform:none;letter-spacing:0;color:#22221E;background:#fff;border:1px solid rgba(43,43,38,.2);padding:10px 12px;border-radius:2px;width:100%;box-sizing:border-box}',
    '.dp-resumen{border-top:1px solid rgba(43,43,38,.12);padding-top:14px;display:grid;gap:8px;font-size:14px}',
    '.dp-fila{display:flex;justify-content:space-between;gap:12px}',
    '.dp-fila.total{font-weight:600;font-size:16px}',
    '.dp-nota{font-size:12.5px;color:#6B6B60;margin:0}',
    '.dp-acciones{display:flex;justify-content:space-between;align-items:center;gap:12px;flex-wrap:wrap}',
    '.dp-btn{font:inherit;font-size:12.5px;letter-spacing:1.2px;text-transform:uppercase;border:0;cursor:pointer;padding:14px 22px;border-radius:999px;background:#7A5E26;color:#fff}',
    '.dp-btn:focus-visible,.dp-precio:focus-visible,.dp-cerrar:focus-visible,.dp-volver:focus-visible{outline:2px solid #374F2D;outline-offset:3px}',
    '.dp-volver{background:none;border:0;font:inherit;font-size:12px;letter-spacing:1px;text-transform:uppercase;cursor:pointer;color:#4D4940;border-bottom:1px solid currentColor;padding:0 0 3px}',
    '.dp-pasarela{border:1px dashed rgba(43,43,38,.3);background:#fff;padding:16px;display:grid;gap:12px}',
    '.dp-pasarela-cab{display:flex;justify-content:space-between;gap:10px;font-size:12px;letter-spacing:.6px;text-transform:uppercase;color:#4D4940}',
    '.dp-campo-sk{height:42px;border:1px solid rgba(43,43,38,.15);border-radius:2px;display:flex;align-items:center;padding:0 12px;font-size:13px;color:#8A877C}',
    '.dp-reloj{font-variant-numeric:tabular-nums;color:#374F2D;font-weight:600}',
    '.dp-ok{text-align:center;display:grid;gap:10px;justify-items:center;padding:8px 0}',
    '.dp-ok .dp-check{width:56px;height:56px;border-radius:50%;background:#374F2D;color:#fff;display:grid;place-items:center;font-size:28px}',
    '.dp-ticket{font-family:ui-monospace,Menlo,monospace;font-size:18px;letter-spacing:2px;border:1px solid rgba(43,43,38,.2);padding:8px 16px}',
    '@media (max-width:480px){.dp-grid{grid-template-columns:1fr}.dp-cuerpo{padding:18px 16px 22px}}',
    '@media (prefers-reduced-motion:reduce){.dp-sk{animation:none}}'
  ].join('\n');
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var SK = '<span class="dp-sk" aria-hidden="true"></span>';
  var SK_TXT = '<span class="sr-only">precio por confirmar</span>';

  /* ── Precio en cada tarjeta ──────────────────────────────────────────── */
  function ponerPrecios() {
    raiz.querySelectorAll('.hab-unidad').forEach(function (li) {
      var acc = li.querySelector('.hab-unidad-acciones');
      if (!acc || acc.querySelector('.dp-precio')) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dp-precio';
      b.innerHTML = '<small>Desde</small><span class="dp-monto">S/ ' + SK + SK_TXT + '<em>/ noche</em></span><span class="dp-ver">Reservar y pagar</span>';
      b.addEventListener('click', function () { abrir(li.querySelector('.hab-unidad-name').textContent.trim()); });
      acc.insertBefore(b, acc.firstChild);
    });
  }
  ponerPrecios();
  document.addEventListener('i18n:change', ponerPrecios);

  /* ── Modal ───────────────────────────────────────────────────────────── */
  var dlg = document.createElement('dialog');
  dlg.className = 'dp-modal';
  dlg.setAttribute('aria-labelledby', 'dpTitulo');
  document.body.appendChild(dlg);
  dlg.addEventListener('click', function (e) { if (e.target === dlg) cerrar(); });
  dlg.addEventListener('close', parar);

  var estado = { hab: '', paso: 1, entrada: '', salida: '', huespedes: '2', nombre: '', correo: '' };
  var reloj = null;

  function hoy(d) {
    var f = new Date(); f.setDate(f.getDate() + d);
    return f.getFullYear() + '-' + String(f.getMonth() + 1).padStart(2, '0') + '-' + String(f.getDate()).padStart(2, '0');
  }
  function noches() {
    var a = Date.parse(estado.entrada), b = Date.parse(estado.salida);
    return a && b && b > a ? Math.round((b - a) / 864e5) : 0;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function abrir(hab) {
    estado = { hab: hab, paso: 1, entrada: hoy(7), salida: hoy(9), huespedes: '2', nombre: '', correo: '' };
    pintar();
    dlg.showModal();
  }
  function cerrar() { dlg.close(); }
  function parar() { if (reloj) { clearInterval(reloj); reloj = null; } }

  function pasos() {
    var n = ['Fechas', 'Tus datos', 'Pago', 'Listo'];
    return '<ol class="dp-pasos">' + n.map(function (t, i) {
      var k = i + 1;
      return '<li' + (k === estado.paso ? ' aria-current="step"' : '') + (k < estado.paso ? ' class="hecho"' : '') + '>' + k + '. ' + t + '</li>';
    }).join('') + '</ol>';
  }
  function resumen() {
    var n = noches();
    return '<div class="dp-resumen">' +
      '<div class="dp-fila"><span>' + n + ' noche' + (n === 1 ? '' : 's') + ' × S/ ' + SK + '</span><span>S/ ' + SK + '</span></div>' +
      '<div class="dp-fila"><span>Desayuno</span><span>Incluido</span></div>' +
      '<div class="dp-fila total"><span>Total</span><span>S/ ' + SK + SK_TXT + '</span></div>' +
      '</div>';
  }

  function pintar() {
    parar();
    var h = '<div class="dp-banda"><span>Vista previa · Reserva directa</span><span>Sin cobros reales</span></div><div class="dp-cuerpo">' +
      '<div class="dp-cab"><h2 id="dpTitulo">' + esc(estado.hab) + '</h2><button type="button" class="dp-cerrar" data-dp="cerrar" aria-label="Cerrar">×</button></div>' + pasos();

    if (estado.paso === 1) {
      h += '<div class="dp-grid">' +
        '<label for="dpEntrada">Llegada<input id="dpEntrada" type="date" value="' + estado.entrada + '" min="' + hoy(0) + '"></label>' +
        '<label for="dpSalida">Salida<input id="dpSalida" type="date" value="' + estado.salida + '" min="' + hoy(1) + '"></label>' +
        '<label for="dpHuespedes">Huéspedes<select id="dpHuespedes"><option>1</option><option selected>2</option><option>3</option></select></label>' +
        '<p class="dp-nota" style="align-self:end">Disponible en esas fechas ✓ <br>(en el sistema real lo confirma el panel del hotel)</p>' +
        '</div>' + resumen() +
        '<div class="dp-acciones"><span class="dp-nota">Check-in 14:00 · Check-out 11:00</span><button type="button" class="dp-btn" data-dp="sig">Continuar</button></div>';
    } else if (estado.paso === 2) {
      h += '<div class="dp-grid">' +
        '<label for="dpNombre">Nombre completo<input id="dpNombre" autocomplete="off" value="' + esc(estado.nombre) + '" placeholder="Ej.: Ana Torres"></label>' +
        '<label for="dpDoc">Documento<input id="dpDoc" autocomplete="off" placeholder="DNI o pasaporte"></label>' +
        '<label for="dpCorreo">Correo<input id="dpCorreo" type="email" autocomplete="off" value="' + esc(estado.correo) + '" placeholder="Para tu confirmación"></label>' +
        '<label for="dpCel">Celular<input id="dpCel" type="tel" autocomplete="off" placeholder="+51"></label>' +
        '</div><p class="dp-nota">Vista previa: estos datos no se envían ni se guardan.</p>' + resumen() +
        '<div class="dp-acciones"><button type="button" class="dp-volver" data-dp="ant">Volver</button><button type="button" class="dp-btn" data-dp="sig">Ir al pago</button></div>';
    } else if (estado.paso === 3) {
      h += '<p class="dp-nota">Tu habitación queda apartada mientras pagas: <span class="dp-reloj" id="dpReloj">10:00</span></p>' +
        '<div class="dp-pasarela" role="group" aria-label="Formulario de la pasarela de pagos (marcador)">' +
        '<div class="dp-pasarela-cab"><span>🔒 Pago seguro</span><span>Formulario de la pasarela</span></div>' +
        '<div class="dp-campo-sk">Número de tarjeta</div>' +
        '<div class="dp-grid"><div class="dp-campo-sk">MM / AA</div><div class="dp-campo-sk">CVV</div></div>' +
        '<p class="dp-nota">Aquí va el formulario oficial de la pasarela elegida (Izipay, Niubiz, Culqi o Mercado Pago). El hotel nunca ve ni guarda los datos de la tarjeta.</p>' +
        '</div>' + resumen() +
        '<div class="dp-acciones"><button type="button" class="dp-volver" data-dp="ant">Volver</button><button type="button" class="dp-btn" data-dp="sig">Pagar S/ ' + SK + '</button></div>';
    } else {
      h += '<div class="dp-ok"><div class="dp-check" aria-hidden="true">✓</div>' +
        '<p style="margin:0;font-family:Cormorant Garamond,Georgia,serif;font-size:24px">Reserva confirmada</p>' +
        '<p class="dp-ticket">LG-0142</p>' +
        '<p class="dp-nota">Código de ejemplo. En el sistema real llega por correo al huésped y, al instante, a recepción como ticket para registrarlo en Xafiro.</p></div>' +
        '<div class="dp-acciones" style="justify-content:center"><button type="button" class="dp-btn" data-dp="cerrar">Cerrar vista previa</button></div>';
    }
    dlg.innerHTML = h + '</div>';

    if (estado.paso === 1) {
      ['dpEntrada', 'dpSalida'].forEach(function (id) {
        dlg.querySelector('#' + id).addEventListener('change', function (e) {
          estado[id === 'dpEntrada' ? 'entrada' : 'salida'] = e.target.value;
          dlg.querySelector('.dp-resumen').outerHTML = resumen();
        });
      });
    }
    if (estado.paso === 3) {
      var s = 600, el = dlg.querySelector('#dpReloj');
      reloj = setInterval(function () {
        s = Math.max(0, s - 1);
        el.textContent = Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0');
        if (!s) parar();
      }, 1000);
    }
    var foco = dlg.querySelector('input, .dp-btn');
    if (foco) foco.focus();
  }

  dlg.addEventListener('click', function (e) {
    var b = e.target.closest('[data-dp]');
    if (!b) return;
    var a = b.dataset.dp;
    if (a === 'cerrar') return cerrar();
    if (estado.paso === 1 && a === 'sig' && !noches()) {
      dlg.querySelector('.dp-nota').textContent = 'La salida debe ser después de la llegada.';
      return;
    }
    if (estado.paso === 2) {
      estado.nombre = dlg.querySelector('#dpNombre').value;
      estado.correo = dlg.querySelector('#dpCorreo').value;
    }
    estado.paso += a === 'sig' ? 1 : -1;
    pintar();
  });
})();
